import { Link } from "react-router-dom";
import { ArrowUpRight, TrendingDown, TrendingUp } from "lucide-react";
import { money, pct } from "@/lib/api";

export default function StockCard({ stock }) {
  const up = stock.change_pct >= 0;
  return (
    <Link to={`/markets/${stock.id}`} className="panel lift group flex flex-col justify-between p-6" data-testid={`stock-card-${stock.ticker}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="font-mono text-lg font-semibold tracking-tight text-white">{stock.ticker}</p>
          <p className="mt-1 text-sm text-slate-400">{stock.name}</p>
        </div>
        <ArrowUpRight className="h-5 w-5 text-slate-500 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-emerald-400" />
      </div>
      <div className="mt-10 flex items-end justify-between">
        <p className="font-mono text-2xl tracking-tight text-white">{money(stock.price)}</p>
        <span className={`inline-flex items-center gap-1 font-mono text-sm ${up ? "text-emerald-400" : "text-red-400"}`}>
          {up ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
          {pct(stock.change_pct)}
        </span>
      </div>
      {stock.sector && <p className="eyebrow mt-4">{stock.sector}</p>}
    </Link>
  );
}
